import React from "react";
import "./index.less";
import { Sensitive } from "./Sensitive";
import { maxlengthContentEditable } from "./const";
// 敏感词过滤容器
class SentsitiveCont extends React.Component {
  constructor(props) {
    super(props);
    this.blurRef = React.createRef();
    this.flag = "";
    this.state = {
      count: 0,
      inputVal: "",
    };
  }
  // 敏感词过滤
  SensitiveFilter = async (e) => {
    const { blurData } = this.props;
    let divCent = this.blurRef.current;
    const placeholder = e.target.getAttribute("data-placeholder");
    if (e.target.innerText == "") {
      blurData({ flag: false, val: "" });
      e.target.style.color = "#5F6367";
      e.target.innerHTML = placeholder;
      return;
    }
    let values = await Sensitive(divCent.innerText);
    blurData(values);
    divCent.innerHTML = "";
    divCent.innerHTML = values.val;
    divCent.style.color = divCent.innerHTML == "" ? "#BFBFBF" : "#000";
    divCent.innerHTML == "" && (divCent.innerHTML = placeholder);
  };
  componentDidMount() {
    const { initVal } = this.props;
    maxlengthContentEditable();
    let refCont = this.blurRef;
    refCont.current.innerHTML = initVal;
    this.setState({ count: initVal.length || 0 });
    this.placedata(refCont);
  }
  placedata = (emement) => {
    const ele = emement.current;
    const placeholder = ele.getAttribute("data-placeholder");
    ele.style.color = "#BFBFBF";
    ele.innerHTML === "" && (ele.innerHTML = placeholder);
    ele.addEventListener("focus", function (e) {
      const value = e.target.innerHTML;
      value === placeholder && (e.target.innerHTML = "");
      ele.style.color = "#000";
    });
  };
  render() {
    const { count } = this.state;
    const { maxCount, botmtext } = this.props;
    return (
      <div
        style={{
          position: "relative",
          paddingBottom: "0.4rem",
        }}
      >
        <div
          ref={this.blurRef}
          style={{
            ...this.props.styles,
            width: "100%",
            border: "1px solid #D9D9D9",
            borderRadius: "0.05rem",
            paddingLeft: "0.1rem",
            overflowY: "scroll",
          }}
          className="spns"
          contentEditable="true"
          suppressContentEditableWarning
          data-max-length={maxCount}
          data-placeholder={this.props.placelder ? this.props.placelder : ""}
          onKeyUp={(e) => {
            if (e.keyCode === 13) {
              document.execCommand("insertHTML", false, "<br/>&zwnj;");
              e.preventDefault();
            }
            let spnFont = Array.from(e.target.querySelectorAll("font"));
            spnFont.length > 0 &&
              spnFont.forEach((item) => {
                item.style.color = "#000";
                console.log(item, "每一个敏感词的标签");
              });
          }}
          onBlur={(e) => {
            this.SensitiveFilter(e);
            e.preventDefault();
          }}
          onInput={(e) => {
            let tatVal = e.target.innerText;
            this.setState({
              count: tatVal.length > maxCount ? maxCount : tatVal.length,
            });
            e.preventDefault();
          }}
          onPaste={(e) => {
            e.preventDefault();
            const text = e.clipboardData.getData("text");
            document.execCommand("insertText", false, text);
          }}
        ></div>
        {!botmtext ? (
          <div
            style={{
              position: "absolute",
              width: "0.8rem",
              height: "0.2rem",
              right: "0.05rem",
              bottom: "0.1rem",
              textAlign: "center",
              background: "#fff",
            }}
          >
            {`${count} / ${maxCount}`}
          </div>
        ) : null}
      </div>
    );
  }
}

export default SentsitiveCont;
